import { Box, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { MainContext } from "../../../../main/context/MainContextProvider";
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export type LossTotalizerCardsProps = {
    totalLoss: number;
    expectedLosses: number;
    recoverableLosses: number;
};

export default function LossTotalizerCards({ totalLoss, expectedLosses, recoverableLosses }: LossTotalizerCardsProps) {
    const { theme } = useContext(MainContext);

    const expectedLossesPercent = totalLoss > 0 ? (expectedLosses / totalLoss) * 100 : 0;
    const recoverableLossesPercent = totalLoss > 0 ? (recoverableLosses / totalLoss) * 100 : 0;

    const cards = [
        {
            title: "Perda Total",
            value: totalLoss,
            icon: <TrendingDownIcon sx={{ color: "#9CA3AF", fontSize: 24 }} />,
            bgColor: "rgba(156, 163, 175, 0.1)",
            iconBgColor: "rgba(156, 163, 175, 0.15)",
            iconColor: "#9CA3AF"
        },
        {
            title: "Perdas Previstas",
            value: expectedLosses,
            percent: expectedLossesPercent,
            icon: <WarningAmberIcon sx={{ color: "#3B82F6", fontSize: 24 }} />,
            bgColor: "rgba(59, 130, 246, 0.1)",
            iconBgColor: "rgba(59, 130, 246, 0.15)",
            iconColor: "#3B82F6"
        },
        {
            title: "Perdas Gerenciáveis",
            value: recoverableLosses,
            percent: recoverableLossesPercent,
            icon: <CheckCircleOutlineIcon sx={{ color: "#f59e0b", fontSize: 24 }} />,
            bgColor: "rgba(245, 158, 11, 0.1)",
            iconBgColor: "rgba(245, 158, 11, 0.15)",
            iconColor: "#f59e0b"
        }
    ];

    return (
        <Grid container spacing={2} sx={{ marginBottom: "16px" }}>
            {cards.map((card, index) => (
                <Grid item xs={12} md={4} key={index}>
                    <Box
                        sx={{
                            padding: "16px",
                            paddingBottom: "18px",
                            backgroundColor: card.bgColor,
                            borderRadius: "8px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            border: `1px solid ${card.iconBgColor}`,
                            height: "-webkit-fill-available"
                        }}
                    >
                        {/* Header */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <Box
                                sx={{
                                    backgroundColor: card.iconBgColor,
                                    borderRadius: "8px",
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                {card.icon}
                            </Box>
                            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: theme.secondaryTextColor }}>
                                {card.title}
                            </Typography>
                        </Box>

                        {/* Values */}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                            <Typography sx={{ fontSize: "28px", fontWeight: "600" }}>
                                {card.value.toFixed(2)} MWh
                            </Typography>
                            {card.percent && (
                                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "500", color: card.iconColor }}>
                                        {card.percent.toFixed(1)}%
                                    </Typography>
                                    <Typography sx={{ fontSize: "12px", color: theme.secondaryTextColor }}>
                                        do total de perdas
                                    </Typography>
                                </Box>)}
                        </Box>
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
}
